import { useCallback, useContext, useEffect, useState } from 'react';
import { findExerciseCategory } from '../util';
import { ExerciseCategoriesContext } from '../../_contexts/ExerciseCategoriesContext';
import { useParams } from 'react-router-dom';
import ModuleContext from '../../_contexts/ModuleContext';
import { getMedialinks, Medialink } from '../../../../api/medialink';
import IdentityContext from '../../../../contexts/IdentityContext';
import MaterialSection from './teacher/MaterialSection';
import StudentMaterialSection from './student/MaterialSection';

function MaterialSections() {
  const { exerciseCategories } = useContext(ExerciseCategoriesContext);
  const { module } = useContext(ModuleContext);
  const {
    identity: { isTeacherAlike },
  } = useContext(IdentityContext);

  const { selectedCategoryId } = useParams();

  const exerciseCategoryWithHierarchy = findExerciseCategory(exerciseCategories, selectedCategoryId || '');

  //should this be extracted to reusable hook?
  const selectedCategory = exerciseCategoryWithHierarchy
    ? exerciseCategoryWithHierarchy[exerciseCategoryWithHierarchy?.length - 1]
    : null;

  const [medialinks, setMedialinks] = useState<Medialink[]>();

  const getMedialinksForExerciseCategory = useCallback(async () => {
    if (!selectedCategory || !module) return;

    const { data } = await getMedialinks(module.id, {
      exerciseCategoryId: selectedCategory.id,
      includeScore: true,
      includeSubModules: true,
    });

    setMedialinks(data);
  }, [module, selectedCategory]);

  useEffect(() => {
    getMedialinksForExerciseCategory();
  }, [getMedialinksForExerciseCategory]);

  if (isTeacherAlike) {
    return (
      <div className="material-section">
        <MaterialSection medialinks={medialinks} getMedialinksForExerciseCategory={getMedialinksForExerciseCategory} />
      </div>
    );
  }

  return (
    <StudentMaterialSection
      medialinks={medialinks}
      getMedialinksForExerciseCategory={getMedialinksForExerciseCategory}
    />
  );
}

export default MaterialSections;
